import {
  KoButton, KoCard, KoCharts, KoCol,
  KoDateFormatter,
  KoDP, KoDropdown, KoEmpty,  KoFlex,   KoLoader, KoModal, KoRow, KoTag, KoText, KoTitle
} from "packages";
import KoIcon from '@kwapio/icons';
import { useEffect, useState } from 'react';
import { BILLABLE_HOURS } from './constant';
import { ProfileAPI } from "pages/profile/profile.service";
import styles from "./timesheet.module.scss";
import { useDispatch } from 'react-redux';
import { add, remove } from 'shared/store/breadcrumbSlice';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import SheetDetails from "./sheetDetails";
import { getDateRange } from "shared/utils";


dayjs.extend(customParseFormat);


const MyTimesheet = ({ showCreate = true, showWeeks = true }) => {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [currentRecord, setCurrentRecord] = useState();
  const[ isOpenWorkspace, setOpenWorkspaceModal] = useState(false);
  const [billableList, setBillableList] = useState();
  const [chartData, setChartData] = useState();
  const [taskCount, setTaskCount] = useState();
  const [weekData, setWeekData] = useState();
  const [totalHoursData, setTotalHoursData] = useState();
  const [selectedWorkspace, setSelectedWorkspace] = useState();
  const [workspaceData, setWorkspaceData] = useState([]);
  const [rejectedCount, setRejectedCount] = useState(0);
  const [filterBy, setFilterBy] = useState(`This Year`);
  const [query, setQuery] = useState({
    startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
    endDate: dayjs().endOf('month').format('YYYY-MM-DD')
  });

  useEffect(() => {
    dispatch(remove());
    dispatch(add([
      {
        title: 'Home',
        path: 'home/timesheet/darft'
      },
      {
        title: 'Time Sheet '
      }
    ]));

    getTaskAssignedCount(query);
    getBillableNonBillableTime(query);
    getCurrentWeekTotalWorkTime(query);
    GetTotalHours(query);
    getRejctedCount(query);
  }, [query]);


  useEffect(() => {
    getWorkspaceData();
  }, []);

  const getRejctedCount = (query) => {
    ProfileAPI.getRejectedCount(query).then(
      (data) => {
        setRejectedCount(data?.rejectCount || 0);
      },
      (err) => {
      }
    );
  };

  const GetTotalHours = (query) => {
    setLoading(true);
    ProfileAPI.getTotalHours(query).then(
      (data) => {
        setLoading(false);
        setTotalHoursData(data);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const convertMinutesToHHMM =(minutes)=>{
    let hours = Math.floor(minutes / 60);
    let remainingMinutes = minutes % 60;
    return `${hours}.${remainingMinutes < 10 ? '0' : ''}${remainingMinutes}`;
  };

  const workSpaceData  = [];
  const workSpaceLabel = [];
  const colors=[];
  if (totalHoursData?.workLogs && totalHoursData?.workLogs.length > 0) {
    totalHoursData?.workLogs.forEach((workspace) => {
      workSpaceData.push(convertMinutesToHHMM(workspace.totalMinutes));
      workSpaceLabel.push(workspace.key);
      colors.push(workspace.colour ? workspace.colour : '#e4e4e4');
    });
  }
  // const colors= ['#2fa561', '#ff647c', '#6258c4', '#6979f8', '#be52f2', '#ffa030', '#11afa1', '#f52f62', '#1c90f5'];

  const formattedData = workSpaceData.map((value, index) => ({
    value,
    itemStyle: {
      color: colors[index % colors.length],
      borderRadius: [4, 4, 0, 0]
    }
  }));

  const WORKING_HOURS = {
    tooltip: {
      trigger: 'item',
      borderWidth:0,
      formatter: function(params) {
        const emp = totalHoursData?.workLogs.find((e) => e.key === params?.name);
        if (!emp) return "";
        return `
          <div style="padding: 2px; border-radius: 5px;border:0px">
            <h3 style="font-weight:700">Workspace</h3>
            <div style="display: flex; align-items: center; margin-bottom: 8px;padding-left:8px">
                <p>${emp.workspaceName}  : </p>
                <span style="color: gray; font-weight:bold"> ${emp.totalHours} hours</span>
            </div>
          </div>
        `;
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      data: workSpaceLabel,
      axisLabel: {
        interval: 0,
        rotate: 0,
        fontSize:10
      }
    },
    yAxis: {
      type: 'value'
    },
    grid: {
      top:'6%',
      left: '2%',
      right: '2%',
      bottom: '8%',
      containLabel: true
    },
    series: [
      {
        name: 'Workspace',
        type: 'bar',
        data: formattedData,
        barWidth: "40%"
      }
    ]
  };

  const getWorkspaceData = (q) => {
    setLoading(true);
    ProfileAPI.getWorkspaceData(q).then(
      (data) => {
        setWorkspaceData(data?.workspace || []);
        setLoading(false);
      },
      () => setLoading(false)
    );
  };


  const getCurrentWeekTotalWorkTime = (query) => {
    setLoading(true);
    // setDataList();
    ProfileAPI.getCurrentWeekTotalWorkTime(query).then(
      (data) => {
        setWeekData(data['totalTime']);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );

  };
  // function timeStringToHours(timeStr) {
  //   const [hours, minutes] = timeStr.split(':').map(Number);
  //   // return hours + minutes / 60;
  //   return (hours + minutes / 60).toFixed(2);

  // }

  const getBillableNonBillableTime = (query) => {
    setLoading(true);
    setChartData();

    ProfileAPI.getBillableNonBillableTime(query).then(
      (data) => {
        setBillableList(data);
        const BillableData = data?.workLogs?.map(entry => (entry.billableHours).replace(":", "."));
        const nonBillableData = data?.workLogs?.map(entry => (entry.nonBillableHours).replace(":", "."));

        const workLogDatesArray = data?.workLogs.map(entry => {
          const date  = new Date(entry.date);
          const day   = date.getDate().toString().padStart(2, '0');
          const month = date.toLocaleString('en-US', { month: 'short' });
          return `${day}-${month}`;
        });

        // const billableData1 = BillableData.map((value, index) => ({
        //   value,
        //   itemStyle: {
        //     borderRadius: [6, 6, 0, 0]
        //   }
        // }));
        // const nonbillableData1 = nonBillableData.map((value, index) => ({
        //   value,
        //   itemStyle: {
        //     borderRadius: [6, 6, 0, 0]
        //   }
        // }));

        const series = [
          {
            name: 'Billable Time',
            type: 'bar',
            stack: 'total',
            emphasis: {
              disabled: true
            },
            data: BillableData
          },
          {
            name: 'Non billable Time',
            type: 'bar',
            stack: 'total',
            emphasis: {
              disabled: true
            },
            data: nonBillableData
          }
        ];

        var stackInfo = {};
        for (let i = 0; i < series[0].data?.length; ++i) {
          for (let j = 0; j < series.length; ++j) {
            const stackName = series[j].stack;
            if (!stackName) {
              continue;
            }
            if (!stackInfo[stackName]) {
              stackInfo[stackName] = {
                stackStart: [],
                stackEnd: []
              };
            }
            const info = stackInfo[stackName];
            const data = series[j].data[i];
            if (data && data !== '-') {
              if (info.stackStart[i] == null) {
                info.stackStart[i] = j;
              }
              info.stackEnd[i] = j;
            }
          }
        }

        for (let i = 0; i < series.length; ++i) {
          const data = series[i].data;
          const info = stackInfo[series[i].stack];
          for (let j = 0; j < series[i].data?.length; ++j) {
            const isEnd = info.stackEnd[j] === i;
            const topBorder = isEnd ? 8 : 0;
            const bottomBorder = 0;
            data[j] = {
              value: data[j],
              itemStyle: {
                borderRadius: [topBorder, topBorder, bottomBorder, bottomBorder]
              }
            };
          }
        }

        let obj = BILLABLE_HOURS;
        obj['xAxis']['data'] = workLogDatesArray;
        obj['series'] = series;
        setChartData(obj);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const getTaskAssignedCount = (query) => {
    setLoading(true);
    ProfileAPI.getTaskAssignedCount(query).then(
      (data) => {
        setTaskCount(data?.taskCount);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const formatTime = (time) => {
    if (!time || typeof time !== "string") return "-";

    const [hours, minutes] = time.split(":").map(Number);
    const formattedHours = hours < 10 ? `0${hours}` : hours;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${formattedHours}h ${formattedMinutes}m`;
  };

  // const monthChange = (date, dateString) => {
  //   const monthMap = {
  //     Jan: "01", Feb: "02", Mar: "03", Apr: "04",
  //     May: "05", Jun: "06", Jul: "07", Aug: "08",
  //     Sep: "09", Oct: "10", Nov: "11", Dec: "12"
  //   };
    
  //   const [monthStr, year] = dateString.split("-");
  //   const month = monthMap[monthStr];
    
  //   setMonthVal(date);

  //   getWorkspaceData(month ? { month: month, year: year } : null);
  // };

  const onChangeWorkspace = (value, status, extra) => {
    value['status'] = status;
    if(extra){
      value['status'] = 0 + ',' + 1 + ',' + 2 + ',' + 3 + ',' + 4 + ',' + 5;
    }
    setSelectedWorkspace(value);
    setOpenWorkspaceModal(true);
  };

  const FILTER = [
    {
      key: "lastWeek",
      label: "Last Week"
    },
    {
      key: "currentWeek",
      label: "This Week"
    },
    {
      key: "lastMonth",
      label: "Last Month"
    },
    {
      key: "currentMonth",
      label: "This Month"
    },
    {
      key: "last3Months",
      label: "Last 3 Months"
    },
    {
      key: "last6Months",
      label: "Last 6 Months"
    },
    {
      key: "currentYear",
      label: "This Year"
    },
    {
      key: "lastYear",
      label: "Last Year"
    }
  ];
    
  
  const getDatabyFilter = ({key}) => {
    let item = FILTER.find((item) => item.key === key);
    setFilterBy(item?.label);
    setQuery(getDateRange(key));
  };

  return (
    <div className={`${styles.wrapper}`}>
      {isLoading && <KoLoader />}
      <KoRow gutter={16}>
        <KoCol span={24}>
          <div className={styles.projectPart}>
            <KoTitle text='Timesheet Overview' level={4} />
            <KoDropdown
              menu={{
                items: FILTER,
                onClick: getDatabyFilter
              }}
              overlayClassName={styles.actionDropdown}
              placement="bottomRight">
              <KoButton label={filterBy} className={'btn'} icon={<KoIcon width={14} height={14} name={'FilterOutlined'} />} />
            </KoDropdown>
          </div>
        </KoCol>
        <KoCol span={8}>
          <div className={styles.cardWrapper}>
            <KoCard className={styles.assignedTask}>
              <div className={styles.assignedTaskWrap}>
                <div className={styles.cardIcon}>
                  <KoIcon name="OrgOutlined" color="#B76E00" />
                </div>
                <div className={styles.content}>
                  <KoText className={styles.count} text={taskCount < 10 ? `0${taskCount}` : taskCount ?? '00'} />
                  <KoText className={styles.name} text="Assigned Tasks" />
                </div>
              </div>
            </KoCard>
            <KoCard className={styles.activeProjects}>
              <div className={styles.activeProjectsWrap}>
                <div className={styles.cardIcon}>
                  <KoIcon name="EmailOutlined" />
                </div>
                <div className={styles.content}>
                  <KoText className={styles.count} text={workspaceData.length} />
                  <KoText className={styles.name} text="Active Projects" />
                </div>
              </div>
            </KoCard>
            <KoCard className={styles.rejectedTimesheet}>
              <div className={styles.rejectedTimesheetWrap}>
                <div className={styles.cardIcon}>
                  <KoIcon name="CalendarOutlined" color="#B71D18" />
                </div>
                <div className={styles.content}>
                  <KoText className={styles.count} text={rejectedCount} />
                  <KoText className={styles.name} text="Rejected Timesheets" />
                </div>
              </div>
            </KoCard>
            <KoCard className={styles.workingHours}>
              <div className={styles.workingHoursWrap}>
                <div className={styles.cardIcon}>
                  <KoIcon name="CalendarOutlined" color="#006C9C" />
                </div>
                <div className={styles.content}>
                  <KoText className={styles.count} text={billableList ? formatTime(weekData) : "00h 00m"} />
                  {/* <KoText className={styles.count} text="40h 30m"/> */}
                  <KoText className={styles.name} text="Total logged hours" />
                </div>
              </div>
            </KoCard>
          </div>
        </KoCol>
        <KoCol span={8}>
          <div className={styles.billableHours}>
            <KoCard className={styles.card}>
              <KoTitle text='Billable Hours' level={5} />
              <div className={styles.billableContent}>
                <div className={styles.chart}>
                  {(billableList && chartData) && <KoCharts option={chartData} />}
                </div>
                <div className={styles.chartHolder}>
                  <div className={styles.chartContent}>
                    <div className={styles.avgWorkTime}>
                      <KoText className={styles.text} text="Avg Work Time" />
                      <KoText className={styles.time} text={billableList ? formatTime(billableList?.averageWorkTime) : "00"} />
                    </div>
                    <div className={styles.billableTime}>
                      <div className={styles.billableText}>
                        <div className={styles.billableCircle} />
                        <KoText className={styles.text} text="Billable Time" />
                      </div>
                      <KoText className={styles.time} text={billableList ? formatTime(billableList?.totalBillableTime) : ""} />
                    </div>
                    <div className={styles.nonBillableTime}>
                      <div className={styles.nonBillableContent}>
                        <div className={styles.nonBillableCircle} />
                        <KoText className={styles.text} text="Non Billable Time" />
                      </div>
                      <KoText className={styles.time} text={billableList ? formatTime(billableList?.totalNonBillableTime) : ""} />
                    </div>
                  </div>
                </div>
              </div>
            </KoCard>
          </div>
        </KoCol>
        <KoCol span={8}>
          <div className={styles.projectBreakdown}>
            <KoCard className={styles.card}>
              <div className={styles.title}>
                <KoTitle text='Workspace Breakdown' level={5} />
                <KoTitle text={formatTime(totalHoursData?.overAllTotalHours)} level={5} />
              </div>
              {/* <div className={styles.projectBar}> */}
              <KoCharts option={WORKING_HOURS} />
              {/* </div> */}
              {/*<div className={styles.projectBar}>
                {
                  totalHoursData?.workLogs?.map((item, index) => (
                    <div className={`${styles[`bar${index + 1}`]}`} key={index} />
                  ))
                }
              </div>
              <div className={styles.projectDesc}>
                <KoList
                  size={'small'}
                  itemLayout="horizontal"
                  dataSource={totalHoursData?.workLogs}
                  renderItem={(item, index) => (
                    <KoList.Item className={styles.descItemWrap} >
                      <div className={styles.projectDesHolder}>
                        <div className={styles.project1}>
                          <div className={styles.projectContent}>
                            <div className={styles[`projectInfo${index + 1}`]} />
                            <KoText className={styles.name} text={item.workspaceName} />
                          </div>
                          <div className={styles.timeInfo}>
                            <KoText className={styles.time} text={formatTime(item.totalHours)} />
                            <div className={styles.projectChart}>
                              <KoCharts option={WORKING_HOURS} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </KoList.Item>
                  )}
                />
              </div>*/}
            </KoCard>
          </div>
        </KoCol>
      </KoRow>
      <KoRow>
        <KoCol span={24}>
          <div className={`${styles.sheetTabs} profileSection`}>
            <KoTitle text="Timesheet Submission & Approval" level={5} className={styles.titleSheetTabs} />
          </div>
        </KoCol>
      </KoRow>
      <KoRow>
        <KoCol span={24}>
          {workspaceData?.length > 0 ? <KoFlex wrap="wrap" gap="small" className={styles.listSection}>
            {workspaceData?.map((wos, i) =>
              <KoCard className={`${styles.woscard} ${wos?.workspace === selectedWorkspace?.workspace ? styles.activeWorkspace :''}`}
                key={wos?.workspace}
                hoverable={true}>
                <div className={styles.aLink}>
                  <div onClick={() => {}} className={styles.panelHeader}>
                    <div className={`${styles.titleKey} profileChar`}>
                      <div className={`${styles.squareDP} ${wos?.name?.charAt(0) ? wos?.name?.charAt(0).toLowerCase() : 'a'}`}>
                        {wos?.['cutomerLogo'] ?
                          <KoDP shape={'default'} logo={wos?.['cutomerLogo']} width={25} height={'auto'} />
                          :
                          <KoText className={`${styles.letter}`} text={wos?.customer?.charAt(0)} />
                        }
                      </div>
                      <div className={styles.titleValue}>
                        <div className={styles.verified}>
                          <KoText className={styles.panelHeaderTitle} ellipsis={true} text={wos?.name} />
                        </div>
                        <KoTitle className={styles.title} ellipsis={true} text={wos?.customer} level={4} />
                      </div>
                    </div>
                  </div>
                  <div className={styles.descriptions} >
                    <div className={styles.panelHeaderTextWrapper}>
                      <KoText text={`Billable . `} className={styles.panelHeaderText} />
                      <KoText text={`${wos?.totalBillableWorkHours ?? 0} `} className={styles.panelHeaderTextBold} />
                      <KoText text={`Non-Billable . `} className={styles.panelHeaderText} />
                      <KoText text={`${wos?.totalNonBillableWorkHours ?? 0} `} className={styles.panelHeaderTextBold} />
                    </div>
                    <div className={styles.panelHeaderTextWrapper}>
                      <KoText className={styles.date} text='Onboarded on: ' />
                      <KoDateFormatter format='DD-MMM-YYYY' data={wos?.onBoarding || wos.createdAt} className={styles.date} />
                    </div>
                  </div>
                  <div className={styles.link}>
                   
                    <div className={`${styles.statusOnWorkspace} customTagLink`}>
                      <KoTag value={'Add Log'} bordered={false} onClick={() => onChangeWorkspace(wos, 0, 5)}/>
                      {/* {wos?.draftCount > 0 &&
                        <KoTag color='draft' radius={true} custom={true} iscount={false} onClick={() => onChangeWorkspace(wos, 0)} value={`Draft - ${wos?.draftCount ?? 0}`} bordered={false} />
                      } */}
                      {/* {wos?.overdueCount > 0 &&
                         <KoTag color='overdue' radius={true}  custom={true} iscount={false}  onClick={() => onChangeWorkspace(wos, 4)} value={`Overdue - ${wos?.overdueCount ?? 0}`} bordered={false} />
                      } */}
                      {wos?.rejectCount > 0 &&
                        <KoTag color='rejected' radius={true} custom={true} iscount={false}  onClick={() => onChangeWorkspace(wos, 3)} value={`Rejected - ${wos?.rejectCount ?? 0}`} bordered={false} />
                      }
                      {wos?.waitingCount > 0 &&
                         <KoTag color='pending' radius={true} custom={true} iscount={false} onClick={() => onChangeWorkspace(wos, 1)} value={`Waiting - ${wos?.waitingCount ?? 0}`} bordered={false} />
                      }
                      {wos?.approvedCount > 0 &&
                         <KoTag color='approved' radius={true} custom={true} iscount={false}  onClick={() => onChangeWorkspace(wos, 2)} value={`Approved - ${wos?.approvedCount ?? 0}`} bordered={false} />
                      }
                    </div>
                  </div>
                </div>
              </KoCard>
            )}
          </KoFlex> :
            <KoFlex wrap="wrap" gap="small" className={styles.emptySection}>
              <KoEmpty subText="Contact your manager for access." icon={'EmptyTwoTone'} title="You have no assigned workspaces" />
            </KoFlex>
          }
        </KoCol>
      </KoRow>

      <KoModal
        title={<div className={styles.modalHeader}>
          <KoDP shape={'default'} logo={selectedWorkspace?.['cutomerLogo']} width={25} height={'auto'} />
          <KoTitle level={5} text={selectedWorkspace?.['name']} />
        </div>}
        centered
        open={isOpenWorkspace}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setOpenWorkspaceModal(false); }}
        onClose={() => { setCurrentRecord(); setOpenWorkspaceModal(false); }}
        width={'98vw'}
        footer={[
          <KoButton key='cancel' label='Close' onClick={() => setOpenWorkspaceModal(false)} />
        ]}
      >
        <SheetDetails setOpenWorkspaceModal={()=>setOpenWorkspaceModal(false)}
          getWorkspaces={getWorkspaceData}
          showCreate={showCreate} currentRecord={currentRecord} project={selectedWorkspace}/>
      </KoModal>

    </div>
  );
};

export default MyTimesheet;
